import { render } from "./TNBView.vue?vue&type=template&id=3b349940"
import script from "./TNBView.vue?vue&type=script&lang=js"
export * from "./TNBView.vue?vue&type=script&lang=js"

import "./TNBView.vue?vue&type=style&index=0&id=3b349940&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__